<template>
          <v-dialog v-model="show" max-width="580" :fullscreen="$vuetify.breakpoint.xs" scrollable >
            <v-card>
                <v-card-title class="headline primary--text fixNotchPaddingTop rundown-dialog-head">
                {{rundown.title}}
                </v-card-title>

                <v-card-text>

                <v-row v-if="loading" cols="12" justify="center"  min-height="400">
                    <v-col class="mx-auto" cols="12">
                        <v-skeleton-loader type="table-tbody" class="mx-auto" max-width="90%"/>
                    </v-col>
                </v-row>

                <v-row v-if="!loading && (!items || items.length==0)" cols="12" justify="center">
                    <v-col class="mx-auto" cols="12" min-height="400" style="text-align:center;">
                            <v-icon style="font-size:6em;" color="grey lighten-1" >mdi-bullhorn-outline </v-icon> 
                            <p style="font-size:1.2em;" color="grey lighten-2">{{$t("ANNOUNCEMENTS_LIST_NO_DATA")}}</p>
                    </v-col>
                </v-row>

                <v-list three-line  flat v-if="!loading  && items && items.length>0" min-height="400">
                <v-list-item-group
                    v-model="selected" 
                    active-class="primary--text"
                >
                    <template v-for="(item, index) in items">
                    <v-list-item :key="item.id" style="padding: 0px; cursor:auto;"> 
                        <template v-slot:default="{  }">
                        <v-list-item-icon style="margin-right: 5px;">
                                <v-icon v-if="item.priority" color="red">mdi-exclamation-thick</v-icon>
                                <v-icon v-if="!item.priority && isNewAnnouncement(item.creationDate)" color="red">mdi-checkbox-blank-circle</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="primary--text" v-text="item.title"></v-list-item-title>
                            <v-list-item-subtitle class="text--blue-grey lighten-4"  v-text="item.email"></v-list-item-subtitle>
                            <!--<v-list-item-subtitle v-if="!active" v-text="item.message"></v-list-item-subtitle>-->
                            <v-list-item-subtitle  v-text="item.message" style="white-space:normal;"></v-list-item-subtitle>
                            <v-list-item-subtitle v-if="item.link">
                                <v-icon  color="grey lighten-1" >mdi-export</v-icon> 
                                <span v-on:click.stop="doOpenLink(item.link)" 
                                    class="primary--text text-decoration-underline" 
                                    style="cursor:pointer;">{{item.link}}</span>
                            </v-list-item-subtitle>
                             <v-list-item-subtitle v-if="item.attachmentName">
                                <v-icon  color="grey lighten-1" >mdi-link-variant</v-icon> 
                                <span v-on:click.stop="doDownload(item)" 
                                    class="primary--text text-decoration-underline" 
                                    style="cursor:pointer;">{{item.attachmentName}}</span> 
                            </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-list-item-action-text v-text="formatLocalDate(item.creationDate)"></v-list-item-action-text>
                            <v-list-item-action-text v-text="formatLocalTime(item.creationDate)"></v-list-item-action-text>
                            <v-icon
                            v-if="isOwner()" v-on:click.stop="doDelete(item, index)" 
                            color="grey lighten-1"
                            >
                            mdi-delete
                            </v-icon> 
                        </v-list-item-action>
                        </template>
                    </v-list-item>

                    <v-divider
                        v-if="index + 1 < items.length"
                        :key="item.id + '-sep'"
                    ></v-divider>
                    </template>
                </v-list-item-group>
                </v-list>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="fixNotchPaddingBottom">
                <v-spacer></v-spacer>
              <v-btn color="secondary rundown-dialog-btn" v-if="isOwner() && !loading" @click="newAnnouncement">{{$t('ANNOUNCEMENTS_LIST_NEW')}}</v-btn>
              <v-btn color="primary rundown-dialog-btn" text @click="close()">{{$t('ANNOUNCEMENTS_LIST_CLOSE')}}</v-btn> 
             </v-card-actions>
      </v-card>


      <v-snackbar
        style="z-index:100002"
        v-model="snackbar"
        :top="true"
        class="fixNotchMarginTop"
        :timeout="2000"
        color="warning"
      >
        {{$t('ANNOUNCEMENTS_LIST_PREMIUM_WARN')}}
        <template v-slot:action="{ attrs }">
          <v-btn color="black" text v-bind="attrs" @click="snackbar = false">{{$t('ANNOUNCEMENTS_LIST_CLOSE')}}</v-btn>
        </template>
      </v-snackbar>
    </v-dialog>
</template>

<script>
 import BaseModule from './BaseModule' 
  export default {
    name: 'AnnouncmentDialog', 
    mixins: [BaseModule],
    props: [],
    data(){
        return {  
             snackbar: false,
             show: false,
             loading: false,
             adminPreview: false,
             user: {
                 id: null
             },
             rundown: {
                 announcementChecked: null,
                 userId: null,
                 parentId: null
             },
              selected: [],
                items: [],
        }

    },  
    methods: {
        close()
        {
            this.show=false
            window.rundownApp.device.backButtonCallback = null;
        },
        doDelete(item, index)
        {

            window.genericConfirm( 
                   this.$t('ANNOUNCEMENTS_DELETE_TITLE'), this.$t('ANNOUNCEMENTS_DELETE_MESAGE'), this.$t('ANNOUNCEMENTS_DELETE_OK'), this.$t('ANNOUNCEMENTS_DELETE_CANCEL'),
                    () => {
                    this.items.splice(index,1);
                    this.loading=true;
                    // eslint-disable-next-line no-unused-vars
                    window.rundownApp.api.deleteAnnouncement(item.id, (res) => {
                            this.loading=false;
                    });
            });
           
            
        },
        doDownload(item)
        {
            window.sp_downloadFile(item.attachmentName, window.rundown_service_url+'/rest/announcement/attachment/'+item.id);
        },
        doOpenLink(url)
        {
            window.sp_openURl(url);
        },
        isOwner()
        {
            return !this.rundown.parentId && !this.adminPreview;
        }, 
        isNewAnnouncement(creationDate) {
            return !this.rundown.announcementChecked || creationDate>this.rundown.announcementChecked;
        },
        newAnnouncement() {

            if (window.isPremium()===false)
            {
                this.snackbar=true;
                return;
            }

            this.$emit('newAnnouncement', {user: this.user,
                                           rundown: this.rundown
                                           });
            this.close();
        },
        showRundownAnnouncements(rundownId)
        {
            
            this.show=true;
            console.log('showRundownAnnouncements:'+rundownId);
            const me = this;
            window.rundownApp.api.getSharedRundown(rundownId,
            function(res){
                    res.rundownId=res.id;
                    res.title=JSON.parse(unescape(res.definition)).rundownData.title;
                    me.showAnnouncements(window.rundownApp.user, res);
            }
            ,function(error){
                    me.loading=false; 
                    console.log(error); 
            });
        },
        showAnnouncements(user,rundown)
        {  
            this.show=true;
            console.log(rundown);
            this.loading=true;
            this.rundown=rundown;
            this.user=user;
            this.item=[];

            window.rundownApp.device.backButtonCallback = this.close;

            this.adminPreview = window.rundownApp.user && rundown.userId != window.rundownApp.user.id
      

            const me = this;
             window.rundownApp.api.getAnnouncementList(rundown.rundownId,
            function(res){
                    me.loading=false;
                    me.items = res; 
            }
            ,function(error){
                    me.loading=false; 
                    console.log(error); 
            });
        } 
      },
  }
</script>